﻿const registrationTypeTypes = {
	Myself: {
		name: "Myself",
		value: "Individual (Myself)"
	},
	SomeoneElse: {
		name: "Someone else",
		value: "Individual (Someone Else)"
	},
	DeceasedEstate: {
		name: "Deceased Estate",
		value: "Deceased Estate"
	}
};

const registrationTypeOptions = [
	{ name: registrationTypeTypes.Myself.name, value: registrationTypeTypes.Myself.value },
	{ name: registrationTypeTypes.SomeoneElse.name, value: registrationTypeTypes.SomeoneElse.value },
	{ name: registrationTypeTypes.DeceasedEstate.name, value: registrationTypeTypes.DeceasedEstate.value }
];

const registrationTypes = {
	types: registrationTypeTypes,
	options: registrationTypeOptions
};

export default registrationTypes;
